/* A list of animations that are optionally available on blocks */
const BLOCK_ANIMATIONS = {
    SLIDE_AND_FADE: 'animationSlideAndFade',
};

export default BLOCK_ANIMATIONS;
